"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("external-svg-loader");
var constants_1 = require("../../constants");
var icons_1 = require("../../constants/icons");
var SvgSpriteLoader = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.viewBox, viewBox = _d === void 0 ? '0 0 24 24' : _d, _e = _a.fillColor, fillColor = _e === void 0 ? 'none' : _e, color = _a.color, _f = _a.iconCategory, iconCategory = _f === void 0 ? icons_1.ICON_SPRITE_TYPES.ALERTS_AND_FEEDBACK : _f, _g = _a.id, id = _g === void 0 ? 'alert-circle' : _g, _h = _a.version, version = _h === void 0 ? 0 : _h, _j = _a.domain, domain = _j === void 0 ? 'https://assets.zamp.finance' : _j, _k = _a.dataCache, dataCache = _k === void 0 ? '' : _k, _l = _a.className, className = _l === void 0 ? '' : _l, _m = _a.onClick, onClick = _m === void 0 ? constants_1.defaultFn : _m, customSpriteUrl = _a.customSpriteUrl;
    return (react_1.default.createElement("div", { onClick: onClick, className: className, "data-testid": "svg-sprite-loader-" + id },
        react_1.default.createElement("svg", { id: id, viewBox: viewBox, width: width, height: height, fill: fillColor, color: color, "data-src": customSpriteUrl !== null && customSpriteUrl !== void 0 ? customSpriteUrl : domain + "/sprites/v" + version + "/" + iconCategory + ".svg#" + id, "data-cache": dataCache })));
};
exports.default = react_1.memo(SvgSpriteLoader);
